export default class ContestNamesSnippetNotFoundError extends Error {}
